// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__1525H","back":"Error_back__3CvTg"};